import Media from '@Components/Plugins/MediaControl';
import translator from '@Components/Utilities/Translator';
import { useEffect } from 'react';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import { waitForGlobalFunction } from '@Components/Utilities/SandhillsUtility';

const MediaControl = (props) => {
    const windowSize = useWindowSize();

    useEffect(() => {
        if (document.readyState !== 'loading') {
            waitForGlobalFunction('mediaControl').then((fn) => {
                fn('media-control');
            }).catch((error) => {
                console.error('Error loading mediaControl function:', error);
            });
        }
        else {
            document.addEventListener('DOMContentLoaded', () => {
                waitForGlobalFunction('mediaControl').then((fn) => {
                    fn('media-control');
                }).catch((error) => {
                    console.error('Error loading mediaControl function:', error);
                });
            });
        }
    }, [windowSize.isMobile]);

    return (
        <Media
            {...props}
            allText={translator.translate('sandhills.all')}
            threeSixtyText={translator.translate('sandhills.360photos')}
            photosText={translator.translate('sandhills.photos')}
            videosText={translator.translate('sandhills.videos')}
        />
    );
};

export default MediaControl;